import Vue from 'vue';
import { each } from 'lodash';

import Modal from './components/modal';
import LoadingSpinner from './components/loading-spinner';
import SiteLink from './components/site-link';
import Stream from './components/stream';
import WPImage from './components/wp-image';
import Template404 from './components/template-404';
import Accordion from './components/accordion';
import Breadcrumbs from './components/breadcrumbs';
import Case from './components/case';
import navigation from './components/navigation';
import range from './components/range';

const GLOBAL_COMPONENTS = {
    Modal,
    SiteLink,
    Stream,
    LoadingSpinner,
    Case,
    'wp-image': WPImage,
    Template404,
    'accordion': Accordion,
    'breadcrumbs': Breadcrumbs,
    navigation,
    range,
};

each(GLOBAL_COMPONENTS, (value, key) => {
    Vue.component(key, value);
});